import SocialBar from "../components/SocialBar/SocialBar";

export default function AvisoDePrivacidad() {
  return (
    <section
      className="bg-dark-gray relative text-white px-6 md:px-12 lg:px-20 py-12 md:py-20 bg-cover bg-center"
      style={{ backgroundImage: "url('/images/fondoBlanco.webp')" }}
    >
      {/* dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative mx-auto text-center max-w-7xl">
        {/* --- Header --- */}
        <h2 className="text-white text-4xl md:text-6xl font-extrabold mb-6 md:mb-10">
          AVISO DE PRIVACIDAD
        </h2>

        <p className="text-gray-300 text-lg md:text-2xl mb-16 max-w-4xl mx-auto px-4">
          Cómo recopilamos, utilizamos y protegemos tu información personal.
        </p>

        {/* --- Content --- */}
        <div className="text-left mx-auto max-w-5xl space-y-10 text-gray-200 text-lg md:text-xl leading-relaxed px-4">
          <p>
            En <strong>Omova Carbon Fiber</strong>, valoramos tu privacidad y
            nos comprometemos a proteger tus datos personales. Este Aviso de
            Privacidad explica cómo recopilamos, utilizamos y protegemos tu
            información cuando visitas nuestra landing page.
          </p>

          {/* 1. Recopilación de Datos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              1. Recopilación de Datos
            </h3>
            <p>
              Al visitar nuestra página, podemos recopilar datos personales como
              tu nombre, correo electrónico, número de teléfono y cualquier otra
              información que decidas proporcionarnos al completar formularios
              de contacto o registro.
            </p>
          </section>

          {/* 2. Uso de la Información */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              2. Uso de la Información
            </h3>
            <p>
              La información recopilada se utiliza para responder a tus
              consultas, proporcionarte información sobre nuestros productos,
              servicios, promociones, y mejorar tu experiencia en nuestra
              página. También podemos utilizarla para enviarte comunicaciones
              relacionadas con nuestros productos o servicios si has consentido
              recibirlas.
            </p>
          </section>

          {/* 3. Protección de Datos */}
          <section>
            <h3 className="text-2xl font-bold mb-4">3. Protección de Datos</h3>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra el acceso no autorizado,
              alteración, divulgación o destrucción.
            </p>
          </section>

          {/* 4. Compartición de Información */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              4. Compartición de Información
            </h3>
            <p>
              No compartimos tu información personal con terceros, salvo cuando
              sea necesario para cumplir con solicitudes específicas que nos
              hagas (por ejemplo, solicitar más información) o cuando la ley lo
              requiera.
            </p>
          </section>

          {/* 5. Derechos del Usuario */}
          <section>
            <h3 className="text-2xl font-bold mb-4">5. Derechos del Usuario</h3>
            <p>
              Puedes solicitar el acceso, rectificación, cancelación u oposición
              al uso de tus datos personales en cualquier momento enviando un
              correo a{" "}
              <a
                href="mailto:contacto@omova.com.mx"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                contacto@omova.com.mx
              </a>
              .
            </p>
          </section>

          {/* 6. Cambios en el Aviso */}
          <section>
            <h3 className="text-2xl font-bold mb-4">
              6. Cambios en el Aviso de Privacidad
            </h3>
            <p>
              Nos reservamos el derecho de modificar este Aviso de Privacidad en
              cualquier momento. Cualquier cambio será notificado a través de
              esta página.
            </p>
          </section>

          {/* Contact */}
          <section>
            <p>
              Para más detalles sobre nuestra política de privacidad o si tienes
              alguna duda, por favor contáctanos en{" "}
              <a
                href="mailto:contacto@omova.com.mx"
                className="text-primary-green underline hover:text-green-400 transition-colors"
              >
                contacto@omova.com.mx
              </a>
              .
            </p>
          </section>
          <SocialBar />
        </div>
      </div>
    </section>
  );
}
